import React, { useState, useEffect } from "react";
import clock from "../Assets/img/Masterclass/Icon ionic-md-time-white.png";
import calendar from "../Assets/img/Masterclass/Icon material-date-range-white.png";
import linkedinButton from "../Assets/img/Masterclass/Component 1.png";
import profileImg from "../Assets/img/Masterclass/Rectangle 1011.png";
import videoImg from "../Assets/img/Masterclass/Rectangle 1040.png";
import masterBanner from "../Assets/img/Masterclass/blogs.png";
import clockB from "../Assets/img/Masterclass/Icon ionic-md-time.png";
import calendarB from "../Assets/img/Masterclass/Icon material-today-black.png";

import styles from "../Assets/css/masterclasspage.module.css";
import styles1 from "../Assets/css/masterclass.module.css";
import Navbar from "../components/Navbar";
import { BASE_URL } from "../env";
import MasterClassComponent from "../componentsofcourse/MasterClassComponent";

function MasterClassPage() {
	const queryParams = new URLSearchParams(window.location.search);
	const refferal = queryParams.get("referral");
	const webinar_id = queryParams.get("webinar");
	const [data, setData] = useState(Object);
	const [startTime, setStartTime] = useState("");
	const [endTime, setEndTime] = useState("");
	const [subject, setSubject] = useState("");
	const [description, setDescription] = useState("");
	const [website_reg_url, setWeb_reg_url] = useState("");
	const [timezone, setTimeZone] = useState("");
	const [registration, setRegistration] = useState([]);
	const [speaker, setSpeaker] = useState("");
	const [speaker_linkedin_profile, setSpeakerLinkedInProfile] = useState("");
	const [about_the_speaker, setAboutTheSpeaker] = useState("");
	const [about_the_webinar, setAboutTheWebinar] = useState("");
	const [count, setCount] = useState(0);
	const [modal, setModal] = useState(false);
	const [image, setImage] = useState("");

	console.log("Webinar id", webinar_id);
	useEffect(() => {
		fetch(BASE_URL + "/createWebinar/" + webinar_id, {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((result) => {
				console.log("Result from MasterclassPage", result);
				setData(result);
				setStartTime(result.webinar.startTime);
				setDescription(result.webinar.description);
				setEndTime(result.webinar.endTime);
				setSubject(result.webinar.subject);
				setWeb_reg_url(result.webinar.website_reg_url);
				setTimeZone(result.webinar.timezone);
				setRegistration(result.webinar.Registrants);
				setImage(result.webinar.image);
				result.webinar.about_the_webinar
					? setAboutTheWebinar(result.webinar.about_the_webinar)
					: setAboutTheWebinar("");

				result.webinar.speaker
					? setSpeaker(result.webinar.speaker)
					: setSpeaker("");

				result.webinar.speaker_linkedin_profile
					? setSpeakerLinkedInProfile(
							result.webinar.speaker_linkedin_profile
					  )
					: setSpeakerLinkedInProfile("");

				result.webinar.about_the_speaker
					? setAboutTheSpeaker(result.webinar.about_the_speaker)
					: setAboutTheSpeaker("");
			});
	}, []);
	const date = new Date(startTime);
	const year = date.getFullYear();
	const month = date.getMonth() + 1;
	const dt = date.getDate();
	const time =
		date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
	if (dt < 10) {
		dt = "0" + dt;
	}
	var months = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	const newDate = `${dt} ${months[month - 1]} ${year}`;

	function formatAMPM(date) {
		var mytime = new Date(date);
		var hours = mytime.getHours();
		var minutes = mytime.getMinutes();
		var ampm = hours >= 12 ? "pm" : "am";
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? "0" + minutes : minutes;
		var strTime = hours + ":" + minutes + " " + ampm;
		return strTime;
	}

	const [masterClassProps, setMasterClassProps] = useState([]);

	useEffect(() => {
		fetch(BASE_URL + "/getWebinar", {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				console.log("Data from CreateWebianr", data);
				setMasterClassProps(data.webinar);
			});
	}, []);
	const handleShow = () => {
		setModal(true);
	};
	const handleClose = () => setModal(false);
	return (
		<div>
			<Navbar />
			<br />
			<div class={`container-fluid ${styles.blogTop}`}>
				{/* <img src={image} alt={image} className="w-100" /> */}
				<h1 class={styles.borderTopH1}>{subject}</h1>
				<h2>
					A <i>Free Masterclass</i> By{" "}
					<span class={styles.nameSpan}>{speaker}</span>
				</h2>
				<hr class={styles.blog1Hr} />
				<div class={styles.dateRangeIconBlog}>
					<img src={calendar} alt="" class="img-fluid" />
					{newDate}
				</div>
				<div class={styles.timeIconBlog}>
					<img src={clock} alt="" class="img-fluid" />
					{formatAMPM(startTime)}
				</div>
			</div>
			<br />
			<br />
			<div class={`container-fluid ${styles.blog1Div2}`}>
				<div class="row">
					<div
						class={`col-xl-8 col-lg-8 col-md-8 col-sm-8 col-11 ${styles.blog1Div02}`}
					>
						<h2 class={styles.blog1Div2H2}>{subject}</h2>
						<span class={styles.boldData1}>Date:</span> {newDate}{" "}
						<span class={styles.boldData}>Time:</span>{" "}
						{formatAMPM(startTime)}
						<span class={styles.boldData}>Duration:</span>{" "}
						{endTime - startTime}{" "}
						<span class={styles.boldData}>Price:</span> Free{" "}
						<span class={styles.boldData}>Venue:</span> Online
					</div>
					<div
						class={`col-xl-3 col-lg-3 col-md-3 col-sm-3 col-11 ${styles.blog1Div2Right}`}
					>
						<div class={styles.registerBtnDiv}>
							<div>
								{/* <a
                  href={"http://localhost:3001/personal?webinar=" + webinar_id}
                  target="popup"
                  onClick={`window.open('http://localhost:3001/personal?webinar='${webinar_id},'popup','width=600,height=600'); return false`}
                >
                  
                </a> */}
								<button
									type="button"
									class={`${styles.registerBtn} btn btn-info btn-lg`}
									onClick={() =>
										window.open(
											"http://localhost:3001/personal?webinar=" +
												webinar_id
										)
									}
								>
									REGISTER
								</button>
							</div>
						</div>
						<div>{registration.length} have Enrolled</div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<div class={`container-fluid ${styles.blog1Div3}`}>
				<div class="row">
					<div class="col-xl-6 col-11">
						<h4>About the Master Class</h4>
						<hr class={styles.blog1Hr2} />
						<br />
						<p>
							We Cantilever Lab is offering our 4.95/5 rated
							Masterclasses at IITs and NITs to you. Yes, you read
							that right, we are giving you our most demanding
							Masterclasses that have helped 120+ students get
							placed in FAANG and other top MNCs last year itself.
							This Masterclass will point out some of the major
							mistakes that every beginner makes and will provide
							you with necessary optimizations techniques and
							strategies to rectify them and gain (achievements)
							as early as possible.
						</p>
						<p>
							<span class={styles.boldData1}>
								Things you will take with you:
							</span>
							<br />
							<ul className={styles.listData}>
								<li>
									Overview of the topic- On how to pace up
									your career, disregarding your position in
									your professional front.
								</li>
								<li>
									Information related to the domain, that
									everyone should follow in order to climb the
									ladder of corporate success!
								</li>
								<li>
									Tips on how to improve themselves and scale
									up their professional proforma.
								</li>
								<li>
									Strategies to stand ahead of others and be
									the leader you desire to be!
								</li>
							</ul>
						</p>

						<p>
							<span class={styles.boldData1}>
								About Cantilever Lab:
							</span>{" "}
							<br />
							At Cantilever Labs, we are dedicated to help our
							candidates achieve their success with whatever means
							it takes, starting from developing their programming
							skills from scratch to preparing them for their
							final interviews by providing one-to-one interview
							rounds,strong resume building kits and many more. We
							also provide the best of experiential learning
							ambience with extensive hours of teaching, hands-on
							experience with practical exercises along with
							technical training and mock interviews with HR’s
							from top companies like Google, Microsoft, Amazon
							etc for a complete preparation. Lastly, we give 100%
							placement assurance, in any desired company.
						</p>

						<p>
							<span class={styles.boldData1}>
								Our achievements so far:
							</span>
							<br />
							<ul className={styles.listData}>
								<li>
									Provided placement guidance to top 10/11
									highest earning students in India.
								</li>
								<li>
									Trained 24k+ job aspirants from IIT Bombay,
									IIT Madras, JNTU, SNIST, GITAM last year.
								</li>
								<li>
									7 out of 8 students from SNIST at Amazon are
									the students placed by Cantilever Labs.
								</li>
								<li>
									120+ students got placed in FAANG companies
									through our placement preparation.
								</li>
							</ul>{" "}
						</p>

						{/* <p>
              {" "}
              <span class={styles.boldData1}>FAQ:</span> <br />{" "}
            </p> */}
					</div>
					<div class="col-xl-5 col-11">
						<div class={`card ${styles.blogpostCard}`}>
							<div class="d-flex">
								{/* <div>
                  <img
                    src={profileImg}
                    alt=""
                    class={`img-fluid ${styles.profileImgBlog}`}
                  />
                </div> */}
								<div>
									{" "}
									{about_the_speaker}
									<br />
									<span class={styles.boldData1}>
										{speaker}
									</span>
									<br />
									<a href={speaker_linkedin_profile}>
										<img
											src={linkedinButton}
											alt=""
											class={styles.linkedinImg}
										/>
									</a>
								</div>
							</div>
						</div>
						<br />
						<div>
							<img src={videoImg} alt="" class="img-fluid" />
						</div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<div class={`container-fluid ${styles.blueSectionDiv}`}>
				<div class="row">
					<div
						class={`col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11`}
					>
						<img src={image} />
					</div>
				</div>
			</div>
			<br />
			<br />
			<div class={`container-fluid ${styles.blog1Div3}`}>
				<div class="row">
					<div class="col-xl-11 xol-lg-11 col-md-11 col-sm-11">
						<h4>Notes</h4>
						<hr class={styles.blog1Hr3} />
						<br />
						<p>
							<ul className={styles.listData}>
								<li>
									We promise to give you a brainstorming
									session. Hence, we expect you to be
									attentive and interactive during the entire
									session.
								</li>
								<li>
									Please keep a pen and notebook while joining
									the session, to take your important notes.
								</li>
							</ul>
						</p>
						<p>
							{" "}
							<span class={styles.boldData1}>Link:</span> <br />
							<ul className={styles.listData}>
								<li>
									We are eagerly waiting to see on (date) at
									(time).
								</li>
								<br />
								<li>Join us: (link to attend the session).</li>
							</ul>
						</p>

						<p>
							{" "}
							<span class={styles.boldData1}>FAQ:</span> <br />
							<ol className={styles.listData}>
								<li>
									<p>
										What is the Masterclass?
										<br />
										The Masterclass is the online session
										organised by Cantilever Labs from time
										to time, that is designed specifically
										to provide you exclusive knowledge
										within the encapsulated time
									</p>
								</li>
								<br />
								<li>
									<p>
										What are the advantages of attaining the
										Masterclass?
										<br />
										You will receive extensive domain
										knowledge along with amazing vouchers
										and gifts that are released after the
										sessions. Foremost, you will get to
										interact with our speakers directly and
										learn from their experience.
									</p>
								</li>
								<br />
								<li>
									<p>
										What is the fee of joining the
										MasterClass?
										<br />
										Our Masterclass is absolutely free and
										anyone can be a part of it.
									</p>
								</li>
								<br />
								<li>
									<p>
										What if we missed the sessions?
										<br />
										We would love to have you in our live
										class, yet in case you couldn’t join our
										Masterclass, don’t worry you can find
										the recordings on our website.
									</p>
								</li>
								<br />
							</ol>{" "}
						</p>

						{/* <p>
              {" "}
              <span class={styles.boldData1}>Links:</span> <br />
              but also the leap into electronic typesetting, remaining
              essentially unchanged. It was popularised in the 1960s with the
              release of Letraset sheets containing Lorem Ipsum passages, and
              more recently with desktop publishing software like Aldus
              PageMaker including versions of Lorem Ipsum.{" "}
            </p>

            <p>
              {" "}
              <span class={styles.boldData1}>FAQ:</span> <br />{" "}
            </p> */}
					</div>
				</div>
			</div>
			{/* ---------------------------------UPCOMING CLASS------------------------------------------------------------------------------------------------- */}
			<div style={{ background: " rgba(81, 153, 251, 0.19)" }}>
				<div
					style={{ paddingTop: "5%", paddingLeft: "5%" }}
					class={`d-flex mx-5 my-4 ${styles.upcomingJ}`}
				>
					<h2>Upcoming Classes</h2>
					<button class="btn mx-5">More</button>
				</div>
				<div className="row justify-content-center">
					{/* <div
            style={{
              paddingRight: "2%",
              paddingTop: "3%",
              paddingBottom: "3%",
              height: "fit-content",
            }}
            className={`col-xl-5 col-lg-5 col-md-7 mx-4 my-2 `}
          > */}
					{count > 3
						? null
						: masterClassProps.map((item) => {
								return (
									<>
										<MasterClassComponent
											topic={item.subject}
											agenda={item.description}
											start_time={item.startTime}
											end_time={item.endTime}
											join_url={item.webinar_join_url}
											registration_url={
												item.registration_url
											}
											webinar_id={item.webinar_id}
										/>
										{setCount(count + 1)}
									</>
								);
						  })}

					{/* </div> */}
					{/* <div
            style={{
              paddingRight: "2%",
              paddingTop: "3%",
              paddingBottom: "3%",
              height: "fit-content",
            }}
            className={`col-xl-5 col-lg-5 col-md-7 mx-4 my-2 `}
          >
            <div className={`card ${styles1.cardsArchivedJ}`}>
              <img
                style={{
                  height: "100px",
                  width: "100%",
                  borderRadius: "10px 10px 0px 0px",
                }}
                src={masterBanner}
                alt="Card image cap"
              />
              <div className={styles1.cardBody}>
                <h5 className="card-title">Title</h5>
                <p style={{ width: "60%" }} className="card-text">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen.
                </p>

                <div className={`d-flex ${styles1.archivedButtonJ}`}>
                  <div className={`d-flex ${styles1.archivedIconJ} mt-4`}>
                    <div style={{ marginRight: "1.5vw" }}>
                      <p className="cal-J">
                        <img src={calendarB} alt="" />
                        SUN, 23rd MAY
                      </p>
                    </div>
                    <div className="mr-5">
                      <p className="clock-J">
                        <img src={clockB} alt="" />
                        5PM - 6PM
                      </p>
                    </div>
                  </div>

                  <div className=" mt-4">
                    <div className="mb-2">
                      <button
                        className={`${styles.btn} ${styles.btnLight} shadow `}
                      >
                        REGISTER
                      </button>
                    </div>
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: " 10px",
                        fontFamily: "Poppins-Black",
                      }}
                    >
                      5673 have Enrolled
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
				</div>
			</div>
		</div>
	);
}

export default MasterClassPage;
